
define(
  'StockInformation.EntryPoint',
  [
    'StockInformation.Model',
    'Cart.AddToCart.Button.View',
    'Cart.Detailed.View',
    'GeoLocation.Service',
    'LiveOrder.Model',
    'GlobalViews.Message.View',
    'underscore',
    'jQuery'
  ],
  function (
    StockInformationModel,
    CartAddToCartButtonView,
    CartDetailedView,
    GeoLocationService,
    LiveOrderModel,
    GlobalViewsMessageView,
    _,
    jQuery
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var environment = container.getComponent('Environment');
        var config = environment.getConfig('stockInformation');
        var host = window.location.host;
        var isHenselite = host.indexOf('henselite') !== -1;
        var isActiveBowls = host.indexOf('activebowls') !== -1;

        var validationLocationIds;
        if (isHenselite) {
          validationLocationIds = (config && config.henseliteAuLocations || ['1']).join(',');
          GeoLocationService.getLocation().done(function (location) {
            if (location.isNZ) {
              validationLocationIds = (config && config.henseliteNzLocations || ['211']).join(',');
            }
          });
        } else if (isActiveBowls) {
          validationLocationIds = (config && config.activeBowlsLocations || ['1', '21', '24']).join(',');
        }

        function getCartQuantityForItem(itemId) {
          var lines = LiveOrderModel.getInstance().get('lines');
          if (!lines) {
            return 0;
          }
          var total = 0;
          lines.each(function (line) {
            var lineItem = line.get('item');
            if (lineItem && String(lineItem.get('internalid')) === String(itemId)) {
              total += parseFloat(line.get('quantity')) || 0;
            }
          });
          return total;
        }

        function checkStock(itemId, quantity) {
          var deferred = new jQuery.Deferred();
          var model = new StockInformationModel();
          model.fetch({
            data: { itemId: itemId, locationsIds: validationLocationIds }
          }).done(function (response) {
            var results = response && response.value && response.value.results || [];
            var available = results.reduce(function (sum, loc) {
              return sum + (parseFloat(loc.quantityavailable) || 0);
            }, 0);
            deferred.resolve({ hasStock: available >= quantity, available: Math.floor(available) });
          }).fail(function () {
            deferred.reject();
          });
          return deferred.promise();
        }

        function showStockError(placeholder, message) {
          placeholder.empty();
          var errorView = new GlobalViewsMessageView({ message: message, type: 'error', closable: false });
          placeholder.html(errorView.render().$el.html());
        }


        _.extend(CartAddToCartButtonView.prototype, {
          addToCart: _.wrap(CartAddToCartButtonView.prototype.addToCart, function (fn, e) {
            var self = this;

            if (!self.model.areAttributesValid(['options', 'quantity'], self.getAddToCartValidators())) {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }

            e.preventDefault();

            var itemId = self.model.getItem && self.model.getItem().get('internalid');
            var quantity = self.model && self.model.get('quantity') ||
              parseInt(self.$('[name="quantity"]').val(), 10) || 1;

            if (!itemId) {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }

            var button = self.$('[data-type="add-to-cart"]');
            var errorPlaceholder = self.$('[data-type="stock-error-placeholder"]');
            if (!errorPlaceholder.length) {
              errorPlaceholder = jQuery('<div data-type="stock-error-placeholder">');
              self.$('.cart-add-to-cart-button-container').after(errorPlaceholder);
            }

            button.prop('disabled', true);
            errorPlaceholder.empty();

            var totalQuantity = getCartQuantityForItem(itemId) + quantity;

            var item = self.model.getItem && self.model.getItem();
            var itemType = item && item.get('itemtype');
            self.itemType = itemType;

            checkStock(itemId, totalQuantity)
              .done(function (result) {
                button.prop('disabled', false);
                if (result.hasStock || (self.itemType === 'GiftCert' || self.itemType === 'GiftCard')) {
                  fn.apply(self, [e]);
                } else {
                  showStockError(errorPlaceholder, 'Insufficient stock. Only ' + result.available + ' units available.');
                }
              })
              .fail(function () {
                button.prop('disabled', false);
                showStockError(errorPlaceholder, 'Unable to verify stock availability. Please try again.');
              });
          })
        });


        _.extend(CartDetailedView.prototype, {
          updateItemQuantity: _.wrap(CartDetailedView.prototype.updateItemQuantity, function (fn, e) {
            var self = this;
            var form = jQuery(e.target || e.currentTarget).closest('form');
            var options = form.serializeObject();
            var lineId = options && options.internalid;

            if (!lineId) {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }

            var lines = self.model && self.model.get('lines');
            var line = lines && lines.get(lineId);
            if (!line) {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }

            var item = line.get('item');
            var itemId = item && item.get('internalid');
            var newQuantity = parseInt(options.quantity, 10) || 1;

            if (!itemId) {
              return fn.apply(this, _.toArray(arguments).slice(1));
            }

            var qtyInput = form.find('[name="quantity"]');

            function revertQuantity(message) {
              qtyInput.val(line.get('quantity')).prop('disabled', false);
              self.$el.find('#' + lineId + ' a').removeAttr('disabled').removeClass('cart-item-link-disabled');
              showStockError(form.find('[data-type="alert-placeholder"]'), message);
            }

            checkStock(itemId, newQuantity)
              .done(function (result) {
                if (result.hasStock) {
                  fn.apply(self, [e]);
                } else {
                  revertQuantity('Insufficient stock. Only ' + result.available + ' units available.');
                }
              })
              .fail(function () {
                revertQuantity('Unable to verify stock. Please try again.');
              });
          })
        });
      }
    };
  });
